import { useMemo } from 'react';
import { useAppStore } from '../store/main';

export function useStaticAppStore() {
  return useMemo(() => {
    const store = useAppStore.getState();
    return store;
  }, []);
}
